// Purpose: banner shown when <15 min remain on the sliding TTL.

import { useEffect, useState } from 'react';
import { useAuth } from '../auth/AuthContext.tsx';

const WARN_THRESHOLD_SECONDS = 15 * 60;

export function SessionExpiryBanner() {
  const { status, user } = useAuth();
  const [secondsLeft, setSecondsLeft] = useState<number | null>(null);

  useEffect(() => {
    if (status !== 'authenticated' || !user) {
      setSecondsLeft(null);
      return;
    }
    const tick = () => {
      const ms = new Date(user.sessionExpiresAt).getTime() - Date.now();
      setSecondsLeft(Math.max(0, Math.floor(ms / 1000)));
    };
    tick();
    const h = setInterval(tick, 15_000);
    return () => clearInterval(h);
  }, [status, user]);

  if (secondsLeft === null || secondsLeft > WARN_THRESHOLD_SECONDS) return null;

  const minutes = Math.ceil(secondsLeft / 60);
  return (
    <div
      role="status"
      className="bg-status-warning-muted border-b border-status-warning/30 text-status-warning px-6 py-2 text-body-s"
    >
      Your session expires in about {minutes} minute{minutes === 1 ? '' : 's'}. Activity extends it;
      otherwise you will be signed out.
    </div>
  );
}
